import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=1ffe12aa&scoped=true"
import script from "./CourseInfo.vue?vue&type=script&lang=ts"
export * from "./CourseInfo.vue?vue&type=script&lang=ts"
import style0 from "./CourseInfo.vue?vue&type=style&index=0&id=1ffe12aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffe12aa",
  null
  
)

export default component.exports